module.exports = __webpack_public_path__ + "media/12_5.b23d76e4.wav";